import { toHandlers as _toHandlers, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "is-valid", "name", "type", "value"]
const _hoisted_2 = ["for"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_InputClear = _resolveComponent("InputClear")!
  const _component_InputShowPassword = _resolveComponent("InputShowPassword")!
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!
  const _directive_autofocus = _resolveDirective("autofocus")!
  const _directive_prohibit_zoom = _resolveDirective("prohibit-zoom")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pt-7", [_ctx.$attrs.class, { 'pb-x6': _ctx.showErrors }]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["c-input", { 'c-input--error': !!_ctx.errorMessage, 'ml-25': _ctx.isSearchType, 'c-input--password-toggle': _ctx.passwordToggleMode }])
    }, [
      _withDirectives(_createElementVNode("input", _mergeProps({
        id: _ctx.fieldId,
        ref: "inputField",
        class: [_ctx.inputCssClass, "c-input__field"],
        "is-valid": _ctx.meta.valid,
        name: _ctx.name,
        type: _ctx.inputType,
        value: _ctx.inputValue
      }, _ctx.fieldAttrs, {
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isFocused = false)),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFocused = true))
      }, _toHandlers(_ctx.validationListeners, true)), null, 16, _hoisted_1), [
        [_directive_autofocus, _ctx.autofocus],
        [_directive_prohibit_zoom]
      ]),
      (_ctx.isSearchType)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.fieldId,
            class: "c-input__search"
          }, [
            _createVNode(_component_c_icon, {
              name: "icon-search",
              width: "16",
              height: "16",
              title: "search"
            })
          ], 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("label", {
        for: _ctx.fieldId,
        class: _normalizeClass(["c-input__label", { 'c-input__label--has-value': !!_ctx.inputValue }])
      }, _toDisplayString(_ctx.maybeRequiredLabel), 11, _hoisted_3),
      (_ctx.inputClear)
        ? (_openBlock(), _createBlock(_component_InputClear, {
            key: 1,
            active: _ctx.showInputClear,
            class: "c-input__clear",
            onClear: _ctx.handleClear
          }, null, 8, ["active", "onClear"]))
        : _createCommentVNode("", true),
      (_ctx.passwordToggleMode)
        ? (_openBlock(), _createBlock(_component_InputShowPassword, {
            key: 2,
            active: _ctx.showPassword,
            class: "c-input__password-toggler",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword =! _ctx.showPassword))
          }, null, 8, ["active"]))
        : _createCommentVNode("", true),
      (_ctx.showErrors)
        ? (_openBlock(), _createBlock(_component_InputErrorMessage, {
            key: 3,
            name: _ctx.name,
            class: "c-input__errors"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}